import { Injectable } from '@angular/core';
import { AdminConfig } from '@shared/interfaces/appInitConfig';

/**
 * Admin Portal features service to get the features details
 */
@Injectable({
  providedIn: 'root'
})
export class AdminPortalFeaturesService {
  private initInProgress = false;
  private featuresCache: AdminConfig = null;

  /**
   * Set features
   * @ param value
   */
  set config(value: AdminConfig) {
    this.featuresCache = value;
  }

  /**
   * Get features
   */
  get config(): AdminConfig {
    if (this.featuresCache) {
      return this.featuresCache;
    } else {
      return {} as AdminConfig;
    }
  }
}
